import { PropsWithChildren } from 'react';
import { layoutPortraitMiniGridStyle } from './layout-portrait-mini.styles.css';

export type LayoutPortraitMiniProps = {
    type?: 'featured' | 'premium';
};

const LayoutPortraitMini: React.FC<
    PropsWithChildren<LayoutPortraitMiniProps>
> = ({ type, children }) => {
    return (
        <div className={layoutPortraitMiniGridStyle({ type })}>{children}</div>
    );
};

export { LayoutPortraitMini };
